import { createAction } from "@reduxjs/toolkit"

import { SaveUserNotePostData, SaveFlagNotePostData, RequestFlagNotesPayload, RequestUserNotesPayload } from './notesDomain'

export const fetchUserNotes = createAction<RequestUserNotesPayload>("FETCH_USER_NOTES_SAGA")
export const fetchFlagNotes = createAction<RequestFlagNotesPayload>("FETCH_FLAG_NOTES_SAGA")
export const saveUserNote = createAction<SaveUserNotePostData>("SAVE_USER_NOTE_SAGA")
export const saveFlagNote = createAction<SaveFlagNotePostData>("SAVE_FLAG_NOTE_SAGA")